module.exports = __webpack_public_path__ + "static/media/bh-bg.bb86356b.png";